import { useState, useCallback, SyntheticEvent } from 'react';
import cn from 'classnames';

import SubmitLikeDropdown from 'components/SubmitLikeDropdown';
import { useTranslationContext, useUserContext } from 'hooks';

import classes from './CounterButton.module.scss';

const DEFAULT_BACKGROUND_COLOR = '#EEF2FC';

export default function CounterButton(props: {
  buttonCount: number;
  buttonText: string;
  isButtonActive?: boolean;
  askButtonColor: string;
  buttonClass?: string;
  handleClick?: () => void;
  handleNewUserClick?: () => void;
  classId?: string;
  hasLikedVideo: boolean;
}) {
  const {
    buttonCount,
    buttonText,
    askButtonColor = DEFAULT_BACKGROUND_COLOR,
    handleClick = () => { },
    handleNewUserClick = () => {setIsSubmitLikeDropdownShown(true)},
    isButtonActive = false,
    classId,
    hasLikedVideo,
  } = props;

  const { isSignedIn } = useUserContext();
  const { t } = useTranslationContext();

  const [isSubmitLikeDropdownShown, setIsSubmitLikeDropdownShown] = useState(false);

  const addClientBackground = useCallback((event: SyntheticEvent<MouseEvent> | any) => {
    event.stopPropagation();

    // event.target.style.backgroundColor = askButtonColor;
  }, []);

  const removeClientBackground = useCallback((event: SyntheticEvent<MouseEvent> | any) => {
    // event.target.style.backgroundColor = DEFAULT_BACKGROUND_COLOR;
  }, []);

  const handleCounterButtonClick = useCallback(() => {
    isSignedIn ? handleClick() : handleNewUserClick();
  }, [handleClick, isSignedIn]);

  return (
    <div id={classId} className={cn(classes.buttonWrapper, 'counterButton')}>
      <button
        onMouseEnter={e => addClientBackground(e)}
        onMouseLeave={e => removeClientBackground(e)}
        className={cn(classes.CounterButton, props?.buttonClass, isButtonActive && classes.active)}
        onClick={handleCounterButtonClick}
        type="button"
      >
        <span className={cn(classes.amount, 'amount')}>{buttonCount}</span>
        <span className={cn(classes.text, 'text')} style={{ color: askButtonColor }}>
          {t(buttonText)}
        </span>
      </button>

      <SubmitLikeDropdown
        isOpen={isSubmitLikeDropdownShown}
        handleClose={() => setIsSubmitLikeDropdownShown(false)}
        handleClick={handleClick}
        hasLikedVideo={hasLikedVideo}
      />
    </div>
  );
}
